import React from "react";
import cx from "clsx";

export const Button = ({
  className,
  onClick,
  children,
  type = "button",
  component: Component,
  ...params
}) => {
  return (
    <Component
      {...params}
      type={type}
      onClick={onClick}
      className={cx(
        className,
        "font-bold flex mx-auto text-primary-300 bg-black border-0 py-2 px-4 focus:outline-none hover:text-white rounded-xl text-2xl"
      )}
    >
      {children}
    </Component>
  );
};
